import { useEffect, useState } from 'react'
import { TiVendorMicrosoft } from '@react-icons/all-files/ti/TiVendorMicrosoft'
import { useMsal, UnauthenticatedTemplate } from '@azure/msal-react'
import { useNavigate } from 'react-router-dom'
import { IoMdLogOut } from '@react-icons/all-files/io/IoMdLogOut'
import Swal from 'sweetalert2'

import { callMsGraph, loginRequest } from '../config/msalConfig'
import Loading from '../components/Loading'
import useSilentLogin from '../hooks/useSilentLogin'
import useLogout from '../hooks/useLogout'

const LoginPage = () => {
	const [loading, setLoading] = useState(true)
	const [isWaitingApprove, setIsWaitingApprove] = useState(false)
	const [waitingMessage, setWaitingMessage] = useState('')
	const { instance, accounts } = useMsal()
	const navigate = useNavigate()
	const { handleSilentLogin } = useSilentLogin()
	const logout = useLogout()

	useEffect(() => {
		if (accounts.length > 0) {
			instance
				.acquireTokenSilent({
					...loginRequest,
					account: accounts[0]
				})
				.then(response => {
					callMsGraph(response.accessToken).then(response => {
						handleSilentLogin(
							{
								...accounts[0],
								email: response.mail
							},
							true
						).then(resp => {
							if (resp.allowRegister) {
								navigate('/register', {
									replace: true,
									state: {
										...accounts[0],
										comID: resp.comID,
										email: response.mail
									}
								})
							}

							if (!resp.allowRegister && !resp.isAllowToSystem) {
								setIsWaitingApprove(true)
								setWaitingMessage(resp.messageShow)
								setLoading(false)
							}

							if (resp.isAllowToSystem) {
								navigate('/home', { replace: true })
							}
						})
					})
				})
		} else {
			setLoading(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleLogin = async () => {
		try {
			setLoading(true)

			await instance.loginRedirect(loginRequest)

			// const { account } = await instance.loginRedirect(loginRequest)

			// const resp = await handleSilentLogin(account)

			// if (resp.allowRegister) {
			// 	navigate('/register', { replace: true, state: account })
			// }

			// if (!resp.allowRegister && !resp.isAllowToSystem) {
			// 	setIsWaitingApprove(true)
			// 	setWaitingMessage(resp.messageShow)
			// 	setLoading(false)
			// }

			// if (resp.isAllowToSystem) {
			// 	navigate('/home', { replace: true })
			// }
		} catch (err) {
			// Swal.fire({
			// 	title: 'Warning!',
			// 	text: 'User cancel',
			// 	icon: 'info',
			// 	confirmButtonText: 'Ok'
			// })
		} finally {
			setLoading(false)
		}
	}

	const handleLogout = () => {
		Swal.fire({
			title: 'Are you sure?',
			text: 'you want to log out',
			icon: 'warning',
			showCancelButton: true,
			cancelButtonColor: '#bbb',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then(result => {
			if (result.isConfirmed) {
				logout()
			}
		})
	}

	if (loading) return <Loading />

	return (
		<>
			<div className="login-page">
				<div className="login-logo">
					<img
						alt=""
						src={`${process.env.PUBLIC_URL}/images/logos/logo-one-platform.png`}
					/>
				</div>

				{isWaitingApprove ? (
					<div className="flex flex-col items-center mt-5">
						<h1 className="text-white text-xl">{waitingMessage}</h1>

						<button className="btn ci5 mt-5" type="button" onClick={handleLogout}>
							<IoMdLogOut />
							<span>Log out</span>
						</button>
					</div>
				) : (
					<UnauthenticatedTemplate>
						<div className="mt-5">
							<button
								className="btn border-2 border-ci1 bg-ci4 text-white px-12 py-2.5"
								onClick={handleLogin}
							>
								<TiVendorMicrosoft size={22} />
								<span>Login With Azure AD</span>
							</button>
						</div>
					</UnauthenticatedTemplate>
				)}
			</div>
		</>
	)
}

export default LoginPage
